import React from 'react'
import Navbar from '../inc/Navbar';
import ScrollToTop from "react-scroll-to-top";
import OngoingProject from './OngoingProject';
function OngoingPage() {
  return (
    <div>
        <Navbar/>
       <br/>
       <br/>
       <br/>
       <br/>
            <br />
              <ScrollToTop smooth top="100" color="maroon" />  

              <OngoingProject/>
          
    </div>
  )
}

export default OngoingPage